import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "booking-toast-host",
  "aria-live": "polite",
  "aria-atomic": "true"
}
const _hoisted_2 = { class: "booking-toast__content" }
const _hoisted_3 = { class: "booking-toast__title" }
const _hoisted_4 = {
  key: 0,
  class: "booking-toast__text"
}
const _hoisted_5 = ["aria-label", "onClick"]

import { storeToRefs } from "pinia";
import {
  useBookingToastStore,
  type BookingToastType,
} from "../../store/useBookingToastStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingToastHost',
  setup(__props) {

const toastStore = useBookingToastStore();
const { toasts } = storeToRefs(toastStore);

function iconClass(type: BookingToastType): string {
  const icons: Record<BookingToastType, string> = {
    success: "vtmx-checkbox-circle-line",
    error: "vtmx-error-warning-line",
    info: "vtmx-information-line",
    warning: "vtmx-alert-line",
  };
  return icons[type];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "booking-toast",
        tag: "div",
        class: "booking-toast-host__list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
            return (_openBlock(), _createElementBlock("output", {
              key: toast.id,
              class: _normalizeClass(["booking-toast", `booking-toast--${toast.type}`])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["booking-toast__icon", iconClass(toast.type)]),
                "aria-hidden": "true"
              }, null, 2),
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(toast.title), 1),
                (toast.text)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(toast.text), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "booking-toast__close",
                "aria-label": _ctx.$t('common.close'),
                onClick: ($event: any) => (_unref(toastStore).dismiss(toast.id))
              }, " × ", 8, _hoisted_5)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})